import { useEffect, useState } from "react";
import { useConf } from "../../context/account/paramsAccount";
import { FormattedMessage } from "react-intl";
import { handleInputChangePrestaMateriel } from "../../functions/inputFunctions/inputFunctions";
import { useError } from "../../context/erreur/erreurContext";
import { Checkbox } from "@progress/kendo-react-inputs";
import NumericInput from "../kendo/numericInput";
import InputTextArea from "../kendo/inputTextArea";
import { ListePresta } from "../../interface/retourPrestation/retourPrestation";
interface DataSendMat {
    e_qte_casse: number | null;
    e_rpl_id: number | null,
    e_qte_ret_uret: number | null;
    e_qte_fact: number | null;
    e_uret_id: null;
    e_laisse_sur_place: boolean;
    e_laisse_sur_place_note: string;
}
const RenderMateriel = ({ sub, details, setDetails, parentId, isValid }: { sub: ListePresta, details: any, setDetails: any, parentId: any, isValid: boolean }) => {
    const { conf, setConf }: any = useConf()
    const { showError } = useError();
    const [dataSend, setDataSend] = useState<DataSendMat>({
        e_rpl_id: parseInt(sub.rpl_id),
        e_qte_casse: sub?.rpl_qte_casse_ukc,
        e_qte_ret_uret: sub?.rpl_qte_ret,
        e_qte_fact: sub?.rpl_qte_fact_uf,
        e_uret_id: null,
        e_laisse_sur_place: sub?.rpl_laisse_sur_place,
        e_laisse_sur_place_note: sub?.rpl_laisse_sur_place_note

    })
    function mergeDataSend(existing: any[] = [], newItem: any) {
        // Cherche si un élément avec le même e_rpl_id existe déjà
        const index = existing.findIndex(item => item.e_rpl_id === newItem.e_rpl_id);

        if (index !== -1) {
            // Remplace l'élément existant
            const updated = [...existing];
            updated[index] = { ...existing[index], ...newItem };
            return updated;
        }

        // Sinon, ajoute le nouvel élément
        return [...existing, newItem];
    }
    useEffect(() => {
        if (sub.rpl_id !== null && sub.rpl_id !== '') {
            setDataSend({
                e_rpl_id: parseInt(sub.rpl_id),
                e_qte_casse: sub?.rpl_qte_casse_ukc,
                e_qte_ret_uret: sub?.rpl_qte_ret,
                e_qte_fact: sub?.rpl_qte_fact_uf,
                e_uret_id: null,
                e_laisse_sur_place: sub?.rpl_laisse_sur_place,
                e_laisse_sur_place_note: sub?.rpl_laisse_sur_place_note
            })
        }
    }, [sub?.rpl_qte_casse_ukc, sub?.rpl_qte_ret, sub?.rpl_qte_fact_uf, sub?.rpl_laisse_sur_place_note, sub?.rpl_laisse_sur_place])
    useEffect(() => {
        if (!dataSend) return;
        const updatePhase = (phase: any): any => {
            if (!phase || phase.rpl_id === null || phase.rpl_id === '') return phase;

            const children = Array.isArray(phase.sous_categorie) ? phase.sous_categorie : [];

            // Si c'est un E, on descend dans les enfants
            if (phase.rpl_type === "E") {
                const hasP = children.some((child: any) => child.rpl_type === "P");

                if (hasP) {
                    return {
                        ...phase,
                        sous_categorie: children.map((child: any) => {
                            if (child.rpl_type === "P") {
                                const containsA = child.sous_categorie?.some(
                                    (sub: any) =>
                                        sub.rpl_type === "A" && parseInt(sub.rpl_id) === dataSend.e_rpl_id
                                ) || child.sous_categorie?.some(
                                    (sub: any) =>
                                        sub.rpl_type === "C" &&
                                        sub.sous_categorie?.some(
                                            (a: any) =>
                                                a.rpl_type === "A" && parseInt(a.rpl_id) === dataSend.e_rpl_id
                                        )
                                );

                                if (containsA) {
                                    return {
                                        ...child,
                                        dataSend: mergeDataSend(child.dataSend, dataSend),
                                        sous_categorie: Array.isArray(child.sous_categorie)
                                            ? child.sous_categorie.map(updatePhase)
                                            : [],
                                    };
                                }
                                return child;
                            } else {
                                return updatePhase(child);
                            }
                        }),
                    };
                } else {
                    // Pas de P, on merge directement dans la phase E
                    return {
                        ...phase,
                        dataSend: mergeDataSend(phase.dataSend, dataSend),
                    };
                }
            } else {
                // details[0] est ton objet central
                const mainDetail = details[0];

                // On récupère ou initialise dataSend[0]
                const currentDataSend = Array.isArray(mainDetail.dataSend) && mainDetail.dataSend.length > 0
                    ? mainDetail.dataSend[0]
                    : {};

                // Pour chaque phase dans details (sauf index 0)
                details.slice(1).forEach((phase: any) => {
                    if (phase.rpl_type === "A" && phase.v_materiel) {
                        const e_rpl_id = parseInt(phase.rpl_id);

                        // Cherche si ce matériel existe déjà dans dataSend
                        const index = mainDetail.dataSend.findIndex((ds: any) => ds.e_rpl_id === e_rpl_id);

                        const updatedData = {
                            e_rpl_id,
                            e_qte_casse: phase.rpl_qte_casse_ukc || 0,
                            e_qte_ret_uret: phase.rpl_qte_ret || 0,
                            e_qte_fact: phase.rpl_qte_fact_uf || 0,
                            e_laisse_sur_place: phase.rpl_laisse_sur_place || false,
                            e_laisse_sur_place_note: phase.rpl_laisse_sur_place_note || null
                        };

                        if (index >= 0) {
                            // Met à jour l'objet existant
                            mainDetail.dataSend[index] = updatedData;
                        } else {
                            // Sinon, ajoute-le
                            mainDetail.dataSend.push(updatedData);
                        }
                    }
                });


            }




            // Cas pour feuilles ou autres types
            return {
                ...phase,
                sous_categorie: children.map(updatePhase),
            };
        };

        setDetails((prevDetails: any) => prevDetails?.map(updatePhase));

        // Gestion du localStorage
        const savedData = localStorage.getItem(`prestaHl_${conf.user.user_code}`);
        let prestas = savedData ? JSON.parse(savedData) : [];

        const updatePrestaRecursive = (presta: any): any => {
            if (!presta || presta.rpl_id === null || presta.rpl_id === '') return presta;
            const children = Array.isArray(presta.sous_categorie) ? presta.sous_categorie : [];

            if (presta.rpl_type === "E") {
                const hasP = children.some((child: any) => child.rpl_type === "P");

                if (hasP) {
                    return {
                        ...presta,
                        sous_categorie: children.map((child: any) => {
                            if (child.rpl_type === "P") {
                                const containsA = child.sous_categorie?.some(
                                    (sub: any) =>
                                        (sub.rpl_type === "A" && (parseInt(sub.rpl_id) === dataSend.e_rpl_id || sub.v_materiel))
                                ) || child.sous_categorie?.some(
                                    (sub: any) =>
                                        sub.rpl_type === "C" &&
                                        sub.sous_categorie?.some(
                                            (a: any) =>
                                                a.rpl_type === "A" && (parseInt(a.rpl_id) === dataSend.e_rpl_id || a.v_materiel)
                                        )
                                );

                                if (containsA) {
                                    return {
                                        ...child,
                                        dataSend: mergeDataSend(child.dataSend, dataSend),
                                        sous_categorie: Array.isArray(child.sous_categorie)
                                            ? child.sous_categorie.map(updatePrestaRecursive)
                                            : [],
                                    };
                                }
                                return child;
                            } else {
                                return updatePrestaRecursive(child);
                            }
                        }),
                    };
                } else {
                    // Pas de P, merge direct si c'est A matériel
                    if (presta.rpl_type === "A" && presta.v_materiel) {
                        return {
                            ...presta,
                            dataSend: mergeDataSend(presta.dataSend, dataSend),
                        };
                    }
                    return presta;
                }
            } else {
                const mainDetail = details[0];

                // On récupère ou initialise dataSend[0]
                const currentDataSend = Array.isArray(mainDetail.dataSend) && mainDetail.dataSend.length > 0
                    ? mainDetail.dataSend[0]
                    : {};

                // Pour chaque phase dans details (sauf index 0)
                details.slice(1).forEach((phase: any) => {
                    if (phase.rpl_type === "A" && phase.v_materiel) {
                        const e_rpl_id = parseInt(phase.rpl_id);

                        // Cherche si ce matériel existe déjà dans dataSend
                        const index = mainDetail.dataSend.findIndex((ds: any) => ds.e_rpl_id === e_rpl_id);

                        const updatedData = {
                            e_rpl_id,
                            e_qte_casse: phase.rpl_qte_casse_ukc || 0,
                            e_qte_ret_uret: phase.rpl_qte_ret || 0,
                            e_qte_fact: phase.rpl_qte_fact_uf || 0,
                            e_laisse_sur_place: phase.rpl_laisse_sur_place || false,
                            e_laisse_sur_place_note: phase.rpl_laisse_sur_place_note || ""
                        };

                        if (index >= 0) {
                            // Met à jour l'objet existant
                            mainDetail.dataSend[index] = updatedData;
                        } else {
                            // Sinon, ajoute-le
                            mainDetail.dataSend.push(updatedData);
                        }
                    }
                });


            }


            // Cas pour les feuilles A matériel
            if (presta.rpl_type === "A" && presta.v_materiel) {
                return {
                    ...presta,
                    dataSend: mergeDataSend(presta.dataSend, dataSend),
                };
            }

            return {
                ...presta,
                sous_categorie: children.map(updatePrestaRecursive),
            };
        };

        const updatedPrestas = prestas.map(updatePrestaRecursive);
        localStorage.setItem(`prestaHl_${conf.user.user_code}`, JSON.stringify(updatedPrestas));
    }, [dataSend, parentId, conf.user.user_code]);



    return (
        <>

            <div className="linePresta ">
                <div className="numericContainer">
                    <p><FormattedMessage id="quantity" />: {sub.rpl_qte_liv}</p>
                </div>
                <NumericInput readOnly={isValid} name={<FormattedMessage id="quantitycasse" defaultMessage="Qté cassée" />} onChange={(value: any) => { handleInputChangePrestaMateriel(sub.rpl_id, setDetails, 'rpl_qte_casse_ukc', value) }} value={sub?.rpl_qte_casse_ukc} ></NumericInput>
                <NumericInput readOnly={isValid} name={<FormattedMessage id="quantityback" defaultMessage="Qté retournée" />} onChange={(value: any) => { handleInputChangePrestaMateriel(sub.rpl_id, setDetails, 'rpl_qte_ret', value) }} value={sub?.rpl_qte_ret} ></NumericInput>
                <NumericInput readOnly={isValid} name={<FormattedMessage id="Qtefacture" defaultMessage="Qté à facturer" />} onChange={(value: any) => { handleInputChangePrestaMateriel(sub.rpl_id, setDetails, 'rpl_qte_fact_uf', value) }} value={sub?.rpl_qte_fact_uf} ></NumericInput>
            </div>
            <div className="containerMaterielsite">
                <Checkbox
                    disabled={isValid}
                    label="Matériel laissé sur site"
                    value={sub?.rpl_laisse_sur_place}
                    onChange={() => {
                        handleInputChangePrestaMateriel(sub.rpl_id, setDetails, 'rpl_laisse_sur_place', sub?.rpl_laisse_sur_place === undefined ? false : !sub?.rpl_laisse_sur_place)
                    }}
                />{
                    sub?.rpl_laisse_sur_place === true ?
                        <div className="descriptionValid">
                            <span className="titleCategory">Commentaire :</span>
                            <InputTextArea
                                readOnly={isValid}
                                name=""
                                onChange={(value: any) =>
                                    handleInputChangePrestaMateriel(sub.rpl_id, setDetails, 'rpl_laisse_sur_place_note', value)
                                }
                                value={sub?.rpl_laisse_sur_place_note}
                            />
                        </div>
                        : false
                }
            </div>
            {/* <svg className="iconValid" onClick={() => { ValidLignePrestaMaterielCasse(dataSend, conf, setConf, showError) }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" /></svg > */}
        </>
    );
};
export default RenderMateriel